export default {
  install(Vue, options) {
    const store = options.store;

    Vue.prototype.$_globalMixin_getDocumentConfig = async function(
      urlEndpoint
    ) {
      const axios = require("axios");
      const response = await axios.get(urlEndpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            process.env.NODE_ENV === "development"
              ? ""
              : store.state.auth.accessToken
          }`
        }
      });

      return Promise.resolve(response.data.data);
    };

    Vue.prototype.$_globalMixin_formatBytes = function(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };
  }
};
